module.exports = __webpack_public_path__ + "static/media/users.b3f7101b.svg";